import UserWrapper from 'modules/home/manage-clients/dashboard/usersettings/UserWrapper';
import UserDetailPage from 'modules/home/manage-clients/dashboard/usersettings/UserDetailPage';
import UserSecurityPage from 'modules/home/manage-clients/dashboard/usersettings/UserSecurityPage';

const UserRoutes = (): any => ({
    path: 'user',
    element: <UserWrapper />,
    children: [
        {
            path: 'details',
            element: <UserDetailPage />,
        },
        {
            path: 'security',
            element: <UserSecurityPage />,
        },
    ],
});

export default UserRoutes;
